import React from 'react';
import { Icon } from './Icon.js';
export const IconChatBubbleBookmark = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M16 3H22V10.5L19 9L16 10.5V3Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M13 5H3V21H4.41602L6.37891 17.5098L6.66504 17H21V13.3623L23 14.3623V19H7.83398L5.87109 22.4902L5.58496 23H1V3H13V5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconChatBubbleBookmark.js.map